const appTypes = ['WebApp', 'Marketing', 'Login', 'Gallery'] as const
export type AppType = (typeof appTypes)[number]

type VisitKey = 'first_visit' | `first_visit_${AppType}`
const referrerKey = 'first_visit_referrer'
const firstAppKey = 'first_visit_site'
const firstUrlKey = 'first_visit_url'

export function getFirstVisitData() {
  const allKeys: VisitKey[] = ['first_visit', ...appTypes.map((t): VisitKey => `first_visit_${t}`)]
  const visitRecord = allKeys.reduce(
    (acc, key) => {
      const val = localStorage.getItem(key)
      if (val) {
        acc[key] = new Date(val)
      }
      return acc
    },
    {} as Partial<Record<VisitKey, Date>>
  )

  return {
    visitRecord,
    firstVisitReferrer: window.localStorage.getItem(referrerKey) ?? undefined,
    firstVisitSite: window.localStorage.getItem(firstAppKey) ?? undefined,
    firstVisitUrl: window.localStorage.getItem(firstUrlKey) ?? undefined
  }
}

export function logFirstVisit(appType: AppType) {
  if (typeof window === 'undefined') {
    return
  }

  const firstKey = 'first_visit'
  const firstVisitRead = window.localStorage.getItem(firstKey)
  if (!firstVisitRead) {
    window.localStorage.setItem(firstKey, new Date().toISOString())
    window.localStorage.setItem(referrerKey, document.referrer.length > 0 ? document.referrer : '$direct')
    window.localStorage.setItem(firstAppKey, appType)
    window.localStorage.setItem(firstUrlKey, location.href)
  }

  const appKey: VisitKey = `first_visit_${appType}`
  const appVisitRead = window.localStorage.getItem(appKey)
  if (!appVisitRead) {
    window.localStorage.setItem(appKey, new Date().toISOString())
  }
}

export function clearFirstVisitData() {
  if (typeof window === 'undefined') {
    return
  }

  const allKeys: VisitKey[] = ['first_visit', ...appTypes.map((t): VisitKey => `first_visit_${t}`)]
  allKeys.forEach((key) => window.localStorage.removeItem(key))
  window.localStorage.removeItem(referrerKey)
  window.localStorage.removeItem(firstAppKey)
  window.localStorage.removeItem(firstUrlKey)
}
